angular.module('gym.bulkImports', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.bulkImports', {
    url: '/bulk_import',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.bulkImports.list', {
    url: '/bulk_imports',
    controller: 'BulkImportsListCtrl',
    template: require('templates/gyms/bulkImports/list.html.slim')
  }).state('gym.bulkImports.new', {
    url: '/bulk_imports/new?type',
    controller: 'NewBulkImportCtrl',
    template: require('templates/gyms/bulkImports/new.html.slim'),
    resolve: {
      meta: ["BulkImports", function(BulkImports) {
        return BulkImports.all('bulk_imports').customGET('meta');
      }],
      policiesMeta: ["PrivacyPolicies", function(PrivacyPolicies) {
        return PrivacyPolicies.get('meta');
      }]
    }
  }).state('gym.bulkImports.show', {
    url: '/bulk_imports/:id',
    controller: 'ShowBulkImportCtrl',
    template: require('templates/gyms/bulkImports/show/show.html.slim'),
    resolve: {
      meta: ["BulkImports", function(BulkImports) {
        return BulkImports.all('bulk_imports').customGET('meta');
      }],
      bulkImport: ["$stateParams", "BulkImports", function($stateParams, BulkImports) {
        return BulkImports.one('bulk_imports', $stateParams.id).get();
      }]
    }
  });
}]);
